import { isArray } from 'lodash-es'
import React, { useContext, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { CompanyContext } from '../../contexts'

export default function ConfirmCompanyForm({ id, company, onSubmit }) {
  const { company_types } = useContext(CompanyContext)
  const {
    errorsFromServer: { confirm: serverErrors },
  } = useSelector((state) => state.companyRequest)

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setError,
    clearErrors,
  } = useForm()

  useEffect(() => {
    if (!company) return

    reset({
      name: company.name,
      company_type: company.company_type,
    })
  }, [company, reset])

  useEffect(() => {
    if (serverErrors) {
      Object.keys(serverErrors).forEach((field) => {
        setError(field, {
          type: 'server',
          message: isArray(serverErrors[field]) ? serverErrors[field].join(', ') : serverErrors[field],
        })
      })
    }

    return () => clearErrors()
  }, [serverErrors, setError])

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} id={id}>
        <div className="form-group">
          <label className="form-label" htmlFor="company_name">
            name
          </label>
          <input
            type="text"
            {...register('name', { required: 'name is required.' })}
            className="form-control dome-input"
            disabled={true}
            readOnly={true}
            id="company_name"
          ></input>
          {errors.name && <p style={{ color: 'red' }}>{errors.name.message}</p>}
        </div>
        <div className="form-group">
          <label className="form-label" htmlFor="company_type">
            company type
          </label>
          <select
            {...register('company_type')}
            className="form-control dome-input"
            id="company_type"
            readOnly={true}
            disabled={true}
          >
            {company_types.map(([value, label], key) => (
              <option key={key} value={value}>
                {label}
              </option>
            ))}
          </select>
        </div>
      </form>
    </>
  )
}
